<template>
    <div id="registerPage">
        <div data-html2canvas-ignore="true" v-show="loader">
            <Loader />
            <!-- <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div> -->
        </div>
        <!-- <div class="weavrLogoContainer">
      <img src="img/brand/weavr.svg" height="100%" alt="Brand Logo Full" />
    </div> -->
        <div class="container-fluid d-flex align-items-center">
            <LanguageSelect />
            <b-row class="hero-login-section d-flex align-items-center">
                <b-col md="7" class="left-img fullBgImg">
                    <div class="login-page-slider">
                        <div class="slider-container">
                            <div v-for="(slide, index) in slides" :key="index"
                                :class="['slide-wrapper', { active: currentSlide === index }]">
                                <div class="slideImgContainer" style="padding-bottom: 0px !important">
                                    <img :src="slide.image" class="img-fluid slide-image" :alt="slide.title" />
                                </div>
                                <div class="slide-content">
                                    <h2>{{ translatedLang[slide.title][selectedLanguage.key] }}</h2>
                                    <p>{{ translatedLang[slide.description][selectedLanguage.key] }}</p>
                                </div>
                            </div>
                            <div class="slider-controls">
                                <div class="slider-dots">
                                    <span v-for="(slide, index) in slides" :key="index"
                                        :class="['dot', { active: currentSlide === index }]" @click="goToSlide(index)">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="brand-slider">
                        <swiper :options="swiperOptions">
                            <swiper-slide v-for="slide in sliderImages" :key="slide.id" class="brand-slide">
                                <img :src="slide.image" :alt="slide.altDec" class="brand-logo" />
                            </swiper-slide>
                        </swiper>
                    </div>
                </b-col>
                <b-col md="5">
                    <div class="weavrLogoContainer">
                        <div style="height: 40px">
                            <img src="Icons_SVG/weavr-login-img.svg" height="100%" alt="Brand Logo Full" />
                        </div>
                    </div>
                    <b-form @submit="registerClient" class="form-container">
                        <h2 class="mainHeading mt-4 mb-0">{{ translatedLang["Sign Up"][selectedLanguage.key] }}</h2>
                        <template v-if="!userVerified">
                            <p class="subHeading mb-0">
                                {{ translatedLang["Enter your business details"][selectedLanguage.key] }}</p>
                            <div class="d-flex gap">
                                <div class="input-group flex-nowrap d-flex flex-column">
                                    <label for="firstName">{{ translatedLang["First Name"][selectedLanguage.key]
                                    }}</label>
                                    <div class="position-relative input-with-icon">
                                        <div class="position-absolute inputIconContainer tw-mt-[2px]">
                                            <img src="Icons_SVG/userIconWeavr.svg" height="100%" alt="user icon" />
                                        </div>
                                        <input id="firstName" type="text" required v-model="firstName"
                                            :placeholder='`${translatedLang["Enter your first name"][selectedLanguage.key]}`' />
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap">
                                    <label for="lastName">{{ translatedLang["Last Name"][selectedLanguage.key]
                                    }}</label>
                                    <div class="position-relative input-with-icon">
                                        <div class="position-absolute inputIconContainer tw-mt-[2px]">
                                            <img src="Icons_SVG/userIconWeavr.svg" height="100%" alt="user icon" />
                                        </div>
                                        <input id="lastName" type="text" required v-model="lastName"
                                            :placeholder='`${translatedLang["Enter your last name"][selectedLanguage.key]}`' />
                                    </div>
                                </div>
                            </div>
                            <div class="input-group">
                                <label for="email">{{ translatedLang["Email"][selectedLanguage.key] }}</label>
                                <div class="position-relative input-with-icon">
                                    <div class="position-absolute inputIconContainer tw-mt-1">
                                        <img src="Icons_SVG/emailWeavr.svg" height="100%" alt="email icon" />
                                    </div>
                                    <input id="email" type="email" required v-model="email"
                                        :placeholder='`${translatedLang["Enter your email address"][selectedLanguage.key]}`' />
                                </div>
                            </div>
                            <div class="input-group">
                                <label for="companyName"> {{ translatedLang["Brand Name"][selectedLanguage.key]
                                }}</label>
                                <div class="position-relative input-with-icon">
                                    <div class="position-absolute inputIconContainer tw-mt-[3px]">
                                        <img src="Icons_SVG/companyIconWeavr.svg" height="100%" alt="email icon" />
                                    </div>
                                    <input id="companyName" type="text" required v-model="companyName"
                                        :placeholder='`${translatedLang["Enter your company name"][selectedLanguage.key]}`' />
                                </div>
                            </div>
                            <!-- <div class="input-group">
                <label for="brandNames">Brand Name(s)</label>
                <div class="position-relative input-with-icon">
                  <div class="position-absolute inputIconContainer">
                    <img src="Icons_SVG/emailWeavr.svg" height="100%" alt="email icon" />
                  </div>
                  <input
                    id="brandNames"
                    type="text"
                    required
                    v-model="brandNames"
                    placeholder="Enter comma separated brand name(s)"
                  />
                </div>
              </div> -->
                            <div class="dropdown-group gap">
                                <label for=""> {{ translatedLang["Region"][selectedLanguage.key] }}</label>
                                <div class="d-flex test">
                                    <div>
                                        <div id="dropdown" style="width:92px; height: 42px;"
                                            @click="showRegionDropdown = !showRegionDropdown">
                                            <!-- <label for="">Region</label> -->
                                            <div class="d-flex">
                                                <span class="country-flag">
                                                    <img :src="require(`../../../public/country-flags-svg/${selectedCountry.image}`)
                                                        " alt="country-flag" />
                                                </span>
                                                <span class="d-flex flex-column justify-content-center ml-2">
                                                    <!-- <i class="fa fa-caret-up"></i>
                          <i class="fa fa-caret-down"></i> -->
                                                    <img v-if="showRegionDropdown" class="handleArrowPossition"
                                                        src="Icons_SVG/flagArrowsCountry.svg" />
                                                    <img v-else src="Icons_SVG/flagArrowsCountry.svg" />
                                                </span>
                                                <!-- <span>
                          {{ selectedCountry.name }}
                        </span> -->
                                            </div>
                                        </div>
                                        <div id="country-dropdown" v-if="showRegionDropdown">
                                            <div id="country-search" class="mx-3 mt-2 mb-3">
                                                <input type="search" v-model="countrySearchQuery" />
                                                <span><i class="fa fa-search"></i></span>
                                            </div>
                                            <div v-for="country of countryCodes" v-if="
                                                country.name
                                                    .toLowerCase()
                                                    .includes(countrySearchQuery.toLowerCase()) ||
                                                country.dial_code
                                                    .toLowerCase()
                                                    .includes(countrySearchQuery.toLowerCase())
                                            " :key="country.code" class="country-list"
                                                @click="() => { selectedCountry = country, showRegionDropdown = false }"
                                                :class="country.name.trim() === selectedCountry.name.trim()
                                                    ? 'active'
                                                    : ''
                                                    ">
                                                <span class="country-flag mr-2">
                                                    <img :src="require(`../../../public/country-flags-svg/${country.image}`)
                                                        " alt="country-flag" />
                                                </span>
                                                <span class="mr-2">{{ country.name }}</span>
                                                <span class="dial-code">{{ country.dial_code }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-group ml-4">
                                        <!-- <label for="phoneNumber">Phone Number</label> -->
                                        <div class="phone-code">
                                            <input id="phoneNumber" type="text" required v-model="phoneNumber"
                                                maxlength="10"
                                                :placeholder='`${translatedLang["Enter your phone number"][selectedLanguage.key]}`' />
                                            <span class="" :style="{ color: phoneNumber ? '#050A13' : '#A1A1A1' }">{{
                                                selectedCountry.dial_code }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button type="button" class="primarycolor w-100 mb-3" style="border-radius: 32px !important"
                                @click="checkEmail">
                                {{ translatedLang["Next"][selectedLanguage.key] }}
                            </button>
                        </template>
                        <template v-else-if="userVerified">
                            <p class="subHeading mb-0">
                                {{ translatedLang["Almost done. Enter your password and you are all set."]
                                [selectedLanguage.key] }}

                            </p>
                            <div class="input-group negative-margin relative">
                                <label for="password">{{ translatedLang["Password"][selectedLanguage.key] }}</label>

                                <div class="position-relative input-with-icon">
                                    <div class="position-absolute inputIconContainer tw-mt-[3px]">
                                        <img src="Icons_SVG/passwordWeavr.svg" height="100%" alt="password icon" />
                                    </div>
                                    <input id="password" :type="showPassword ? 'text' : 'password'" v-model="password"
                                        :placeholder='`${translatedLang["Enter password"][selectedLanguage.key]}`' />
                                    <i class="fa fa-eye showhidePassword" v-if="!showPassword"
                                        @click="showPassword = true"></i>
                                    <i class="fa fa-eye-slash showhidePassword" v-if="showPassword"
                                        @click="showPassword = false"></i>
                                </div>
                            </div>
                            <b-row class="validity-req-list mt-3 mb-2">
                                <b-col cols="6" class="my-1" v-for="validityReq of passwordRequirements"
                                    :key="validityReq.id" :style="validityReq.color">
                                    <span class="mr-2">
                                        <i class="fa fa-circle" :style="validityReq.color"></i>
                                    </span>
                                    <span>{{ validityReq.msg }}</span>
                                </b-col>
                            </b-row>
                            <div>
                                <div class="input-group negative-margin">
                                    <label for="confPassword">
                                        {{ translatedLang["Confirm password"][selectedLanguage.key] }}</label>
                                    <div class="position-relative input-with-icon">
                                        <div class="position-absolute inputIconContainer tw-mt-[3px]">
                                            <img src="Icons_SVG/passwordWeavr.svg" height="100%" alt="password icon" />
                                        </div>
                                        <input id="confPassword" :type="showConfPassword ? 'text' : 'password'"
                                            v-model="confPassword"
                                            :placeholder='`${translatedLang["Confirm password"][selectedLanguage.key]}`' />
                                        <i class="fa fa-eye showhidePassword" v-if="!showConfPassword"
                                            @click="showConfPassword = true"></i>
                                        <i class="fa fa-eye-slash showhidePassword" v-if="showConfPassword"
                                            @click="showConfPassword = false"></i>
                                    </div>
                                </div>
                                <div class="mt-3" :style="registerValidation.confirmPassword.color">
                                    {{ registerValidation.confirmPassword.msg }}
                                </div>
                            </div>
                            <div class="d-flex align-items-center mt-3 mb-3">
                                <input type="checkbox" name="" id="TnC" class="mr-2" required
                                    v-model="termsAndCondition" />
                                <label for="TnC" class="mb-0">I agree to the
                                    <span class="redirect">Terms and Conditions</span></label>
                            </div>
                            <button type="submit" class="primarycolor w-100 mb-3">
                                {{ translatedLang["Sign Up"][selectedLanguage.key] }}
                            </button>
                        </template>
                        <h4 class="redirect mt-3">
                            {{ translatedLang["Already registered?"][selectedLanguage.key] }}
                            <span class="ml-3" @click="$router.push('/')">
                                {{ translatedLang["Login here"][selectedLanguage.key] }} !</span>
                        </h4>
                    </b-form>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import countryCodes from "../../json/countryCodes.json";
import Loader from "../Components/Loader.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import LanguageSelect from "../Components/LanguageSelect.vue";
import { mapState, mapActions } from "vuex";
import "swiper/css/swiper.css";
export default {
    name: "Register",
    components: {
        Loader,
        Swiper,
        SwiperSlide,
        LanguageSelect
    },
    data() {
        return {
            loader: false,
            userVerified: false,
            firstName: "",
            lastName: "",
            email: "",
            companyName: "",
            brandNames: "",
            phoneNumber: "",
            password: "",
            showPassword: false,
            confPassword: "",
            showConfPassword: false,
            termsAndCondition: false,
            slides: [
                {
                    image: "Icons_SVG/LqsImgLogin.svg",
                    title: "Magnify your eCommerce Presence with Weavr",
                    description: "Analyse multilingual customer reviews to pinpoint key factors influencing ratings and drive product improvements",
                },
                // {
                //   image: "Icons_SVG/pincodeLoginLeftImg.svg",
                //   title: "Pin code-level Availability Tracking",
                //   description:
                //     "Check stock availability with pin code-level tracking, optimizing your location-based inventory systems",
                // },
                {
                    image: 'Icons_SVG/dataInsightsLoginImg.svg',
                    title: 'Unified Marketing Data Insights',
                    description: 'Integrate 50+ marketing channels in a single dashboard. Get in-depth campaign insights to supplement your marketing efforts and boost e-commerce business efficiency.'
                }
            ],
            currentSlide: 0,
            sliderImages: [
                {
                    id: 1,
                    altDec: "Meta icon",
                    image: "Icons_SVG/metaLoginImgNew.svg",
                },
                {
                    id: 2,
                    altDec: "Google Analytics Icon",
                    image: "Icons_SVG/GaLoginImgNew.svg",
                },
                {
                    id: 3,
                    altDec: "Twitter Icon",
                    image: "Icons_SVG/twitterLoginImgNew.svg",
                },
                {
                    id: 4,
                    altDec: "Snapchat Icon",
                    image: "Icons_SVG/snapchatLoginImg.svg",
                },
                {
                    id: 5,
                    altDec: "indiagate",
                    image: "Icons_SVG/shopifyLoginImg.svg",
                },
            ],
            swiperOptions: {
                slidesPerView: 5,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                speed: 900,
            },
            countryCodes: null,
            selectedCountry: {
                name: "India",
                code: "IN",
                emoji: "🇮🇳",
                unicode: "U+1F1EE U+1F1F3",
                image: "IN.svg",
                dial_code: "+91",
            },
            showRegionDropdown: false,
            countrySearchQuery: "",
            passwordRequirements: [
                {
                    msg: "Have at least a number",
                    color: "",
                    id: 1,
                    criteria: /\d/,
                    valid: false,
                },
                {
                    msg: "Have at least one lowercase letter",
                    color: "",
                    id: 2,
                    criteria: /[a-z]/,
                    valid: false,
                },
                {
                    msg: "Have at least one uppercase letter",
                    color: "",
                    id: 3,
                    criteria: /[A-Z]/,
                    valid: false,
                },
                {
                    msg: "Have at least one special character",
                    color: "",
                    id: 4,
                    criteria: /[!@#$%^&*(),.?":{}|<>]/,
                    valid: false,
                },
                {
                    msg: "Have at least 8 character",
                    color: "",
                    id: 5,
                    criteria: /^.{8,}$/,
                    valid: false,
                },
            ],
            registerValidation: {
                // email: {
                //   flag: "invalid",
                //   msg: ""
                // },
                // companyName: {

                // }
                confirmPassword: {
                    color: "",
                    msg: "",
                    valid: false,
                },
            },
        };
    },
    computed: {
        ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    },
    created() {
        this.countryCodes = countryCodes.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();

            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    },
    //   mounted() {},
    mounted() {
        document.addEventListener("click", this.handleClickOutsideForCountryDropdown);
        this.startSlideShow();

    },
    beforeUnmount() {
        if (this.slideInterval) {
            clearInterval(this.slideInterval);
        }
    },
    watch: {
        password: {
            handler(newVal, oldVal) {
                this.passwordRequirements.forEach((req) => {
                    if (req.criteria.test(newVal)) {
                        req.color = "color: #1ACF85";
                        req.valid = true;
                    } else {
                        req.color = "color: #FD5542";
                        req.valid = false;
                    }
                });
            },
            deep: true,
        },
        confPassword(newVal, oldVal) {
            if (!newVal.length) {
                this.registerValidation.confirmPassword.color = "";
                this.registerValidation.confirmPassword.msg = "";
                this.registerValidation.confirmPassword.valid = false;
            } else if (newVal !== this.password) {
                this.registerValidation.confirmPassword.color = "color: #FD5542";
                this.registerValidation.confirmPassword.msg = "Passwords does not match";
                this.registerValidation.confirmPassword.valid = false;
            } else {
                this.registerValidation.confirmPassword.color = "color: #1ACF85";
                this.registerValidation.confirmPassword.msg = "Passwords matched";
                this.registerValidation.confirmPassword.valid = true;
            }
        },
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutsideForCountryDropdown);
    },
    methods: {
        ...mapActions("DemoStore", [
            "setselectedLanguage",
            "initializeTranslation",
        ]),

        handleClickOutsideForCountryDropdown(event) {
            const countryDropdown = this.$el.querySelector(".test");
            if (
                countryDropdown &&
                !countryDropdown.contains(event.target)) {
                this.showRegionDropdown = false;
            }
        },

        startSlideShow() {
            if (this.slideInterval) {
                clearInterval(this.slideInterval);
            }
            this.slideInterval = setInterval(() => {
                this.nextSlide();
            }, 3000);
        },
        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        },
        goToSlide(index) {
            if (index === this.currentSlide) return;
            this.currentSlide = index;
            this.startSlideShow();
        },
        loginClient() { },

        validateEmail() {
            // Check if email is empty
            if (!this.email || this.email.trim() === "") {
                this.showToast("Please enter your email.", "danger");
                return false;
            }

            // Trim whitespace
            const trimmedEmail = this.email.trim();

            // Check email length (max 254 characters per RFC 5321)
            if (trimmedEmail.length > 254) {
                this.showToast("Email is too long.", "danger");
                return false;
            }

            // Basic email regex pattern
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(trimmedEmail)) {
                this.showToast("Please enter a valid email address.", "danger");
                return false;
            }

            // More strict email validation (RFC 5322)
            const strictEmailRegex = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!strictEmailRegex.test(trimmedEmail)) {
                this.showToast("Please enter a valid email address.", "danger");
                return false;
            }

            // Check if email doesn't have consecutive dots
            if (trimmedEmail.includes("..")) {
                this.showToast("Email cannot contain consecutive dots.", "danger");
                return false;
            }

            // Check if email starts or ends with a dot
            if (trimmedEmail.startsWith(".") || trimmedEmail.endsWith(".")) {
                this.showToast("Email cannot start or end with a dot.", "danger");
                return false;
            }

            return true;
        },

        showToast(message, variant = "danger") {
            this.$bvToast.toast(message, {
                title: "Weavr Sense",
                variant: variant,
                toaster: "b-toaster-top-right",
                autoHideDelay: 3000,
            });
        },

        validatePhoneNumber() {
            // Check if phone number is empty
            if (!this.phoneNumber || this.phoneNumber.trim() === "") {
                this.showToast("Please enter your phone number.", "danger");
                return false;
            }

            // Remove any spaces, dashes, or special characters for validation
            const cleanedPhone = this.phoneNumber.replace(/\D/g, "");

            // Check minimum length (adjust based on your requirements)
            if (cleanedPhone.length < 10) {
                this.showToast("Phone number must be at least 10 digits.", "danger");
                return false;
            }

            // Check maximum length
            if (cleanedPhone.length > 15) {
                this.showToast("Phone number is too long.", "danger");
                return false;
            }

            // Check if it contains only numbers (after removing formatting)
            if (!/^\d+$/.test(cleanedPhone)) {
                this.showToast("Phone number must contain only digits.", "danger");
                return false;
            }

            // Optional: Validate specific country format (example for US: +1)
            // if (!this.phoneNumber.startsWith("+1") && !this.phoneNumber.startsWith("1")) {
            //     this.showToast("Please enter a valid US phone number.", "danger");
            //     return false;
            // }

            return true;
        },

        showToast(message, variant = "danger") {
            this.$bvToast.toast(message, {
                title: "Weavr Sense",
                variant: variant,
                toaster: "b-toaster-top-right",
                autoHideDelay: 3000,
            });
        },
        validateName(name, fieldName = "Name") {
        // Check if name is empty
            if (!name || name.trim() === "") {
                this.showToast(`Please enter your ${fieldName.toLowerCase()}.`, "danger");
                return false;
            }

            // Trim whitespace
            const trimmedName = name.trim();

            // Check maximum length (60 characters)
            if (trimmedName.length > 60) {
                this.showToast(`${fieldName} cannot exceed 60 characters.`, "danger");
                return false;
            }

            // Check minimum length (at least 2 characters)
            if (trimmedName.length < 2) {
                this.showToast(`${fieldName} must be at least 2 characters.`, "danger");
                return false;
            }

            // Allow only letters, spaces, and hyphens (for names like Mary-Jane, O'Brien)
            const nameRegex = /^[a-zA-Z\s'-]+$/;
            if (!nameRegex.test(trimmedName)) {
                this.showToast(`${fieldName} can only contain letters, spaces, and hyphens. Numbers and special characters are not allowed.`, "danger");
                return false;
            }

            return true;
        },
        checkEmail() {
            this.userVerified = false;

            const url = "/api/demo/register/verify";
            const payload = {
                email_address: this.email.trim(),
                company_name: this.companyName.trim(),
                country_code: this.selectedCountry.dial_code.trim(),
                phone_number: this.phoneNumber.trim(),
            };

            // if (!this.firstName) {
            //     this.$bvToast.toast(`Please enter your first name.`, {
            //         title: "Weavr Sense",
            //         variant: "danger",
            //         toaster: "b-toaster-top-right",
            //         autoHideDelay: 3000,
            //     });
            //     return;
            // }
            // if (!this.lastName) {
            //     this.$bvToast.toast(`Please enter your last name.`, {
            //         title: "Weavr Sense",
            //         variant: "danger",
            //         toaster: "b-toaster-top-right",
            //         autoHideDelay: 3000,
            //     });
            //     return;
            // }
            if (!this.validateName(this.firstName, "First name")) {
                return;
            }

            if (!this.validateName(this.lastName, "Last name")) {
                return;
            }
            if (!this.validateEmail()) {
                return;
            }
            if (!this.companyName) {
                this.$bvToast.toast(`Please enter your company name.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-top-right",
                    autoHideDelay: 3000,
                });
                return;
            }
            if (!this.validatePhoneNumber()) {
                return;
            }
            this.loader = true;
            this.$http
                .post(url, payload)
                .then((response) => {
                    this.loader = false;
                    this.userVerified = true;
                })
                .catch((err) => {
                    this.loader = false;
                    this.userVerified = false;
                    this.$bvToast.toast(`${err.body.summary}`, {
                        title: "Weavr Sense",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                });
        },
        
        registerClient(e) {
            e.preventDefault();

            let tempBrandNames = [];
            if (this.brandNames.length) {
                tempBrandNames = this.brandNames.split(",").map((brand) => brand.trim());
            }

            /* Validations */
            for (let validateField of this.passwordRequirements) {
                if (!validateField.valid) {
                    this.$bvToast.toast(`Password should ${validateField.msg.toLowerCase()}.`, {
                        title: "Weavr Sense",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                    return;
                }
            }

            if (!this.registerValidation.confirmPassword.valid) {
                this.$bvToast.toast(`Password and confirm password do not match.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-top-right",
                    autoHideDelay: 3000,
                });
                return;
            }

            if (!this.termsAndCondition) {
                this.$bvToast.toast(
                    `Please read the privacy policy and accept the terms and conditions.`,
                    {
                        title: "Weavr Sense",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    }
                );
                return;
            }

            this.loader = true;
            const url = "/api/demo/register";
            const payload = {
                first_name: this.firstName.trim(),
                last_name: this.lastName.trim(),
                country_code: this.selectedCountry.dial_code.trim(),
                phone_number: this.phoneNumber.trim(),
                company_name: this.companyName.trim(),
                brand_name: [this.companyName.trim()],
                email_address: this.email.trim(),
                password: this.password.trim(),
                region: this.selectedCountry.name,
            };
            this.$http
                .post(url, payload)
                .then((res) => {
                    localStorage.setItem("userRegister", true);
                    let reviewUserData = {
                        data: {
                            token: res.body.data.token,
                            username: this.companyName,
                            email: this.email,
                            region_id: res.body.data.region_id,
                            region_name: res.body.data.region_name,
                            clientRegister: res.body.data.clientRegister,
                        },
                    };
                    localStorage.setItem("reviewUserData", JSON.stringify(reviewUserData));
                    localStorage.setItem("clientRegister", JSON.stringify(res.body.data.clientRegister));
                    localStorage.setItem('coupon_applied', false)
                    let items = [
                        {
                            name: "Form",
                            url: "/demo-form",
                            icon: "icon-chart",
                        },
                    ];
                    localStorage.vocSidebar = JSON.stringify(items);
                    window.location = "#/registration-form";
                    this.loader = false;
                })
                .catch((err) => {
                    console.log(`Error in registering the client::${err}`, err);
                    this.$bvToast.toast(`${err.body.summary}.`, {
                        title: "Weavr Sense",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                    this.loader = false;
                });
        },
    },

};
</script>
<style scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: #000 !important;
    transition: background-color 5000s ease-in-out 0s;
}

#registerPage {
    font-family: "Poppins", sans-serif;
    background-color: white;
}

.login-page-slider {
    position: relative;
    width: 100%;
    height: 87vh;
    overflow: hidden;
    /* background-color: #0655590D !important;
    background: url('../../../public/Icons_SVG/bgImgLogin.svg') no-repeat right center; */
}

.showhidePassword {
    position: absolute;
    top: 35%;
    right: 3%;
    color: #c3c3c3;
    cursor: pointer;
}

.form-container label {
    font-size: 14px;
    font-weight: 400;
    font-family: 'Poppins';
    color: #505050;
}

.mainHeading {
    color: #000;
    font-family: 'Poppins';
    font-weight: 600 !important;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0%;
}

.subHeading {
    font-size: 16px;
    color: #050A13;
    font-weight: 400;
    font-family: 'Poppins';
    margin-bottom: 24px !important;
    margin-top: 16px !important;
}

.redirect {
    color: #050A13;
    font-family: Poppins;
    font-weight: 400;
    font-size: 16px;
}

.redirect span {
    color: var(--primary_brand) !important;
    cursor: pointer !important;
    font-family: Poppins;
    font-weight: 600;
    font-size: 16px;
}

.weavrLogoContainer {
    padding: 0 1rem;
    /* margin-left: 0.5rem; */
}

/* .weavrLogoContainer img {
  height: 45px;
} */

.container-fluid {
    height: 100vh !important;
    padding: 0 !important;
    /* gap: 10rem; */
}

.hero-login-section {
    width: 100%;
    height: 100% !important;
}

.left-img {
    padding: 0 !important;
    width: 44%;
}

.login-page-img img {
    height: 89vh !important;
    width: 100%;
    padding-bottom: 10px;
}

.form-container {
    width: 70%;
    margin: 0 auto;
    /* padding-top: 40px; */
}

.negative-margin {
    margin-bottom: -10px !important;
}

.gap {
    gap: 5%;
}

.dropdown-group {
    display: flex;
    flex-direction: column;
}

.dropdown-group>div:first-child {
    width: 60%;
}

#dropdown {
    position: relative;
    padding: 9.5px 16px;
    border-radius: 5PX;
    border: 1px solid #AEAEAE;
    cursor: pointer;
    /* margin-top: 10px; */
}

#dropdown label {
    position: absolute;
    color: var(--primary_brand);
    background-color: white;
    top: -14px;
    left: 20px;
    font-size: 16px;
    padding-inline: 4px;
}

#dropdown i {
    font-size: 18px !important;
    margin-block: -4px !important;
    color: #5e5e5e;
    max-height: 43px;
    text-overflow: ellipsis;
}

#country-search {
    height: 35px;
    border: 1px solid var(--primary_brand-80);
    border-right: none;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#country-search input {
    border: none;
    width: 90%;
    padding-inline: 16px;
}

#country-search input:focus {
    box-shadow: none !important;
    outline: none !important;
    border: none;
}

#country-search input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

#country-search input:-moz-autofill {
    box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

#country-search span {
    color: white;
    background-color: var(--primary_brand);
    height: 100%;
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
}

#country-dropdown {
    position: absolute;
    background-color: white;
    border-radius: 7px;
    max-height: 150px;
    overflow-y: auto;
    border: 1px solid #d9d9d9;
    padding-block: 10px;
    margin-top: 10px;
    width: 50%;
}

.country-list {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 7px 24px;
    cursor: pointer;
    border-bottom: 1px solid #d9d9d9;
}

.dial-code {
    border: 0.5px solid #afafaf;
    color: #afafaf;
    font-size: 12px;
    border-radius: 20px;
    padding: 4px 14px;
}

.phone-code span {
    position: absolute;
    left: 3%;
    top: 18%;
    height: 65%;
    display: flex;
    align-items: center;
}

#phoneNumber {
    padding-left: 3.5rem !important;
}

.country-list:hover {
    background-color: var(--primary_brand-10);
    color: var(--primary_brand-80);
}

.country-list.active {
    background-color: var(--primary_brand);
    color: white;
}

.country-list.active>.dial-code {
    color: white;
    border-color: white;
}

.input-group {
    position: relative;
    margin-bottom: 1.3rem;
    flex-direction: column !important;
}

/* .input-group label {
  position: absolute;
  color: var(--primary_brand);
  background-color: white;
  top: -2px;
  left: 20px;
  font-size: 16px;
  padding-inline: 4px;
} */
.input-group input {
    padding: 10px 12px 10px 40px;
    border: 1px solid #AEAEAE;
    width: 100%;
    height: 100%;
    background: #fff !important;
    outline: none !important;
    border-radius: 5px;
    box-shadow: none !important;
}

.input-group input:focus {
    box-shadow: none !important;
    outline: none !important;
    border: 1.5px solid var(--primary_brand) !important;
}

.input-group input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

.input-group input:-moz-autofill {
    box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

.error-flag {
    font-size: 12px;
    margin: 0;
    padding-top: 2px;
    padding-left: 6px;
    margin-top: 4px;
}

.error-flag .valid {
    color: green;
}

.error-flag .invalid {
    color: red;
}

.error-flag .invalid i {
    padding: 2px 3px;
    border: 1px solid red;
    border-radius: 50%;
}

.error-flag .valid i {
    padding: 2px 3px;
    border: 1px solid green;
    border-radius: 50%;
}

.country-flag img {
    width: 30px;
    height: 20px;
    /* border-radius: 50%; */
    object-fit: cover;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 12px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
    border: none;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

.validity-req-list {
    font-size: 12px;
    color: #919191;
}

.validity-req-list i {
    color: #e8e8e8;
}

/* slider css */
.slider-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.slide-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transform: translateX(-100%);
    /* Enter from left */
    transition: all 0.5s ease-in-out;
    visibility: hidden;
}

.slide-wrapper.active {
    opacity: 1;
    transform: translateX(0);
    visibility: visible;
}

.slide-wrapper:not(.active) {
    transform: translateX(100%);
    /* Exit to right */
    opacity: 0;
}

/* .slideImgContainer {
    padding: 9rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
} */

.slideImgContainer {
    padding-left: 15rem;
    padding-right: 15rem;
    padding-top: 4rem;
    padding-bottom: 40px !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.slide-image {
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
}

.slide-content {
    position: absolute;
    top: 0%;
    left: 5%;
    max-width: 70%;
    padding: 2rem;
    z-index: 2;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.slide-content h2 {
    color: var(--primary_brand);
    font-family: Poppins;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    /* letter-spacing: 0%; */
    text-shadow: none !important;
}

.slide-content p {
    font-family: Poppins;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #000;
    text-shadow: none !important;
}

.slider-controls {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 3;
}

.slider-dots {
    display: flex;
    gap: 10px;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #c4c4c4;
    cursor: pointer;
    transition: all 0.3s ease;
}

.dot.active {
    background: var(--primary_brand);
    transform: scale(1.2);
}

.fullBgImg {
    background-color: #0655590d !important;
    background: url("../../../public/Icons_SVG/bgImgLogin.svg") no-repeat right center;
    height: 100vh;
    position: relative;
}
</style>

<style scoped>
.brand-slider {
    width: 100%;
    padding: 1rem;
}

.brand-logo {
    width: 14rem;
    height: auto;
    object-fit: contain;
}

.brand-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.swiper-container) {
    overflow: hidden;
}

.weavrLogoContainer {
    width: 75%;
    margin: 0 auto;
}

.inputIconContainer {
    padding: 10px 14px 14px 16px;
}

/* .inputIconContainer {
  top: 50%;
  transform: translateY(-50%);
} */

.inputIconContainer img {
    width: 16px !important;
    height: 16px !important;
}

input::placeholder {
    color: #A1A1A1 !important;
    font-size: 14px !important;
    font-family: 'poppins' !important;
}

img.handleArrowPossition {
    transform: rotate(180deg);
    transition: .3s ease-in-out;
}
</style>
